// extracted by mini-css-extract-plugin
export default {"root":"BadgeWrapper_root__Q4TJp","loader":"BadgeWrapper_loader__FBYWv","rotating":"BadgeWrapper_rotating__fJTFz","notification":"BadgeWrapper_notification__gs6uO"};